import type { Community } from '@/domain/communities';
import { api } from '@/utils/configuration';
import { crudService } from '@/utils/request';
import type { GenericAbortSignal } from 'axios';

export const CommunityService = {
  findIdByDomain: async (signal?: GenericAbortSignal) =>
    await crudService.get<{ orgId: number; communityId: number }>(`${api.COMMUNITIES}/id`, {
      signal,
    }),

  findById: async (id: number, signal?: GenericAbortSignal) =>
    await crudService.get<Community>(`${api.COMMUNITIES}/${id}`, { signal }),
};
